module.exports = __webpack_public_path__ + "fonts/Raleway-Medium.0c8c5471.ttf";